import { EventBus } from '@/services/globalEventBus';

export default new EventBus();

export const events = {
  CLEAR_REPORTS_FILTER: 'reportsFilter.clear',
};
